module.exports = __webpack_public_path__ + "static/media/amex.b3a1dcdb.jpg";